import $axios from '@/service/httpServer'

export const getRecruitList = params=>$axios.get(`/pdp/xcx/recruit/announcement`, params); //获取招募公告列表

export const getRecruitInfo = params=>$axios.get(`/pdp/xcx/recruit/detail`, params); //获取招募公告详情

export const getBiddingList = params=>$axios.get(`/pdp/xcx/bidding/announcement`, params); //获取招标公告列表

export const getBiddingInfo = params=>$axios.get(`/pdp/xcx/bidding/detail`, params); //获取招标公告详情

export const getWinBiddingList = params=>$axios.get(`/pdp/xcx/winning/announcement`, params); //获取中标公告列表

export const getWinBiddingInfo = params=>$axios.get(`/pdp/xcx/winning/detail`, params); //获取中标公告详情

export const getBiddingProgress = params=>$axios.get(`/pdp/xcx/bidding/progress`, params); //获取招标进度


